<script lang="ts" setup>
import { ref, watch } from "vue";
import { ATTACHMENT_ACCEPT } from "@/constants/chat";

const props = withDefaults(
  defineProps<{
    file: File | null;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "update:file", value: File | null): void;
}>();

const attachment = ref<HTMLInputElement | null>(null);

watch(
  () => props.file,
  (file) => {
    if (!file && attachment.value) {
      attachment.value.value = "";
    }
  },
);

function chooseFile() {
  attachment.value?.click();
}

function fileChanged(event: Event) {
  const selected = (event.target as HTMLInputElement).files?.[0];

  if (selected) {
    emit("update:file", selected);
  }
}
</script>

<template>
  <div class="d-flex align-center">
    <v-icon :disabled="disabled" @click="chooseFile"> mdi-attachment</v-icon>
    <input
      ref="attachment"
      :accept="ATTACHMENT_ACCEPT"
      :disabled="disabled"
      class="file-input"
      name="attachment"
      type="file"
      @change="fileChanged"
    />
  </div>
</template>

<style lang="scss" scoped>
.file-input {
  width: 0;
  height: 0;
  opacity: 0;
}
</style>
